// Locked Edge palette (storyboard: "Both implementations must use these exact
// values"). Colour carries meaning here, so each value has exactly one job:
//   green / red — price behaviour only (close above / below open). Red is never
//                 used to mean "wrong".
//   gold        — "this is what we are teaching" and "correct".
//   teal        — neutral registration before Submit.
export const EDGE = {
  green: "#35B23C",
  red: "#C43D3D",
  gold: "#D7C588",
  teal: "#004C50",
  // App ink ladder (tailwind bodyInk / secondary / tertiary) for text, the
  // neutral "Your answer" treatment and the teaching-zone outline.
  ink: "#1A1A1A",
  neutral: "#6B7280",
  muted: "#9CA3AF",
  // Two greys of one family (client: "faint gray for structural lines/outlines;
  // a stronger mid-gray for the 'your answer' marker"). Structure recedes; the
  // learner's own tap reads as a marker but stays behind the gold correction.
  line: "#D1D5DB",
  answer: "#9CA3AF",
};
